import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ContentNugget } from '@backrs_ui/common-ui';

import { NuggetCardList } from '@backrs_ui/grow-ui/src/components/NuggetCards/NuggetCardList';
import { handlePanelNuggetClick } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';

import { Box, SxProps, Theme } from '@mui/material';

type GuideNuggetRowProps = Readonly<{
  nuggets: ContentNugget[];
  onNuggetClick?: (nugget: ContentNugget) => void;
}>;

/** Horizontally scrolling row of nugget cards for guide pages. Works with any nugget variant. */
export const GuideNuggetRow: React.FC<GuideNuggetRowProps> = ({ nuggets, onNuggetClick }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (nugget: ContentNugget) => {
      if (onNuggetClick) {
        onNuggetClick(nugget);

        return;
      }

      handlePanelNuggetClick(nugget, navigate);
    },
    [onNuggetClick, navigate],
  );

  return (
    <Box sx={rowSx}>
      <NuggetCardList
        nuggets={nuggets}
        onClick={handleClick}
        direction="scrollingRow"
        hideActions
      />
    </Box>
  );
};

const rowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};
